import React from 'react';

interface ChatEmptyStateProps {
    icon: string;
    title: string;
    subtitle?: string;
    /** 'list' = top aligned (sidebar), 'panel' = vertically centered (right side) */
    variant?: 'list' | 'panel';
}

export const ChatEmptyState: React.FC<ChatEmptyStateProps> = ({
    icon,
    title,
    subtitle,
    variant = 'list',
}) => (
    <div
        className={
            variant === 'panel'
                ? 'flex flex-1 h-full flex-col items-center justify-center text-center p-6'
                : 'flex flex-col items-center text-center px-6 pt-2 pb-6'
        }
    >
        <img
            src={icon}
            alt=""
            draggable={false}
            className="w-[112px] h-[112px] select-none"
        />
        <p className="text-base font-normal font-['Plus_Jakarta_Sans'] text-gray-500 leading-6">
            {title}
        </p>
        {subtitle && (
            <p className="text-sm font-normal font-['Plus_Jakarta_Sans'] text-gray-400 leading-5">
                {subtitle}
            </p>
        )}
    </div>
);
